import { makeStyles, mergeClasses } from "@griffel/react";
import {
  SplitButtonState,
  splitButtonClassName,
  useSplitButtonStyles_unstable,
} from "@fluentui/react-button";

// eslint-disable-next-line no-restricted-imports
import { AppSplitButtonState } from "@1js/acui-button/lib/Next";
import { getRibbonButtonSizedStyles } from "../../next/commonRibbonButtonStyles";
import { customTokens } from "@1js/acui-theme";

// TODO: we should not have to recreate these classnames from Fluent
// ADO: 5647865
export const splitButtonClassNames = {
  primaryActionButton: `${splitButtonClassName}-primaryActionButton`,
  menuButton: `${splitButtonClassName}-menuButton`,
};

const useRootStyles = makeStyles({
  base: {
    ":hover": {
      [`& .${splitButtonClassNames.primaryActionButton}`]: {
        borderColor: customTokens.legacy_neutralLighter,
      },
      [`& .${splitButtonClassNames.menuButton}`]: {
        borderColor: customTokens.legacy_neutralLighter,
      },
    },
    ":active": {
      [`& .${splitButtonClassNames.primaryActionButton}`]: {
        borderColor: customTokens.legacy_neutralQuaternaryAlt,
      },
      [`& .${splitButtonClassNames.menuButton}`]: {
        borderColor: customTokens.legacy_neutralQuaternaryAlt,
      },
    },
  },
  large: {
    flexDirection: "column",
    minWidth: "40px",

    // Have to do this because of Fluent style in useSplitButtonStyles
    // Specificity is greater than a regular class name on the MenuButton
    [`& .${splitButtonClassNames.menuButton}`]: {
      borderLeftWidth: "1px",
    },
  },
});

const useToggledRibbonSplitButtonStyles = makeStyles({
  base: {
    [`& .${splitButtonClassNames.primaryActionButton}`]: {
      borderColor: customTokens.legacy_neutralLight,
    },
    [`& .${splitButtonClassNames.menuButton}`]: {
      borderColor: customTokens.legacy_neutralLight,
    },
  },
});

export const useRibbonSplitButtonStyles = (state: AppSplitButtonState) => {
  const { toggleable, toggled } = state;

  const rootStyles = useRootStyles();
  const toggledRootStyles = useToggledRibbonSplitButtonStyles();

  state.root.className = mergeClasses(
    rootStyles.base,
    getRibbonButtonSizedStyles(state.size, rootStyles),
    toggleable && toggled && toggledRootStyles.base,
    state.root.className
  );

  useSplitButtonStyles_unstable(state as SplitButtonState);

  return state;
};
